<ng-container *transloco="let t">
  @for (media of medias(); track media.id; let idx = $index) {
    <pxc-image-overlay
      [attr.data-testid]="'media-' + media.id"
      [showDelete]="showDelete() && !disabled() && !readOnly()"
      (delete)="removeMedia(media)">
      <pxc-sequence-media
        class="cursor-zoom-in"
        [attr.data-testid]="'seq-media-' + media.id"
        [media]="media"
        (click)="mediaClickedIdx.emit(idx)" />
    </pxc-image-overlay>
  }

  @for (file of files(); track file) {
    <pxc-file-media-preview
      [attr.data-testid]="'file-' + file.name"
      [file]="file"
      [showDelete]="showDelete() && !disabled() && !readOnly()"
      (delete)="removeFile(file)" />
  }

  @for (file of rejectedFiles(); track file.name) {
    <pxc-image-overlay [showDelete]="showDelete() && !disabled() && !readOnly()" (delete)="removeRejected(file)">
      <div
        class="flex aspect-square w-full select-none flex-col items-center justify-center gap-2 rounded-sm bg-background-error-primary p-2">
        <tui-icon class="text-text-error-primary" icon="@tui.image-off" />
        <p class="line-clamp-2 max-w-full break-all text-center text-sm text-text-secondary">
          {{ file.name }}
        </p>
        <p class="text-center text-xs text-text-secondary">
          {{ isTooLarge(file) ? fileTooLargeMessage() : t("Ce fichier n'est pas pris en charge") }}
        </p>
      </div>
    </pxc-image-overlay>
  }

  @if (!readOnly()) {
    <label
      class="min-h-32 aspect-square w-full"
      tuiInputFiles
      [ngClass]="{
        'rounded-sm!': hasFiles(),
        'col-span-full aspect-auto! min-h-40!': !hasFiles(),
      }">
      <input
        ngDefaultControl
        tuiInputFiles
        [accept]="accept()"
        [attr.data-testid]="uploadMode() === 'custom' ? 'image-input-add' : 'image-input'"
        [disabled]="disabled()"
        [maxFileSize]="maxFileSize()"
        [multiple]="true"
        [ngModel]="uploadMode() === 'custom' ? [] : files()"
        (click)="onInputClick($event)"
        (ngModelChange)="onInputFilesChange($event)"
        (reject)="onReject($event)" />
      <ng-template let-dragged>
        <pxc-dropzone-content
          [draggedLabel]="t('Déposez l\'image ici !')"
          [isDragged]="dragged"
          [label]="
            hasFiles()
              ? null
              : (label() ??
                (isLongVideoEnabled() ? t('Ajoutez vos images ou vos vidéos ici') : t('Ajoutez vos images ici')))
          " />
      </ng-template>
    </label>
  }
</ng-container>
